// IE 2026 09 14 / ODOO-… (заказ Игоря: иконки столов под стили): картинки рабочих областей (images/icon-*.png из записей рабочих областей и плиток Launchpad) — IE 2026 11 02 / ODOO-349799 (workspace-wording)
// в схемах иконок (Style 1с … 7w) заменяются глифами семейства — как и остальные иконки платформы; Classic оставляет картинки.
// Ключ — имя файла картинки; класс — pi ie-ico-ws-<ключ> (маски-фолбэк tools/icons/ie_icons.py, соответствия icon_schemes.py).
export const WS_IMG_ICONS = {
    'icon-process-model.png': 'sop',
    'icon-gear.png': 'core',
    'icon-DATA-HUB.png': 'datahub',
    'icon-DEMAND-FORECASTING.png': 'sales',
    'icon-INVENTORY-OPTIMIZER.png': 'distribution',
    'icon-MANUFACTURING-PLANNER.png': 'manufacturing',
    'icon-master-data.png': 'workdata',
    'icon-records.png': 'records',
}
export function wsIconKey(img) {
    if (!img || typeof img !== 'string') return null
    const file = img.split('?')[0].split('/').pop()
    return WS_IMG_ICONS[file] || null
}
// класс глифа для картинки стола в текущей схеме иконок; null — оставить <img> (Classic или незнакомая картинка)
export function wsIconClass(img, iconScheme) {
    if (!iconScheme || iconScheme === 'classic') return null
    const key = WS_IMG_ICONS[img] ? WS_IMG_ICONS[img] : wsIconKey(img)
    return key ? 'pi ie-ico-ws-' + key : null
}
